import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../../context/CookieConsentContext';
import FooterCurves from '../../assets/images/footer-curves.svg';
import UE from '../../assets/images/union-europea.svg';
import DatadisPartner from '../../assets/images/logos/datadis_partner.png';
import DatadisPartnerWebP from '../../assets/images/logos/datadis_partner.webp';
import logoUpv from '../../assets/images/logos/logo-upv.svg';
import logoUnef from '../../assets/images/logos/UNEF-logo_2025.png';
import enisaLogo from '../../assets/images/logos/enisa.png';
import nvidiaInceptionBadge from '../../assets/images/logos/nvidia-inception-program-badge.svg';
import Logo from '../../assets/images/logos/Logo_Trimergy_color.svg';
import Location from '../../assets/images/icons/ico_location.svg';
import Phone from '../../assets/images/icons/ico_phone.svg';

const Footer = () => {
  const { openPreferences } = useCookieConsent();

  const serviceLinks = [
    { label: 'Calculadora de ahorro', path: '/calc/' },
    { label: 'Ecotrim', path: '/ecotrim/' },
    { label: 'Geotrim', path: '/geotrim/' },
    { label: 'Consulta personalizada', path: '/contact/' },
  ];

  const policyLinks = [
    { label: 'Aviso Legal', path: '/legal/' },
    { label: 'Política de Privacidad', path: '/privacidad/' },
    { label: 'Accesibilidad', path: '/accesibilidad/' },
    { label: 'Cookies', path: '/cookies/' },
    { label: 'Nosotros', path: '/nosotros/' },
  ];

  const contactItems = [
    { label: 'info@trimergy.io', href: 'mailto:info@trimergy.io' },
  ];

  const partnerLogoLinks = [
    {
      key: 'eu',
      href: 'https://european-union.europa.eu/index_es',
      className: 'footer-eu-logo',
      image: (
        <img
          src={UE}
          alt="Financiado por la Unión Europea"
          className="footer-eu-logo-img"
        />
      ),
    },
    {
      key: 'enisa',
      href: 'https://www.enisa.es/',
      className: 'footer-enisa-logo',
      image: (
        <img
          src={enisaLogo}
          alt="Financiada por ENISA, Ministerio de Industria y Turismo"
          className="footer-enisa-logo-img"
          loading="lazy"
          decoding="async"
        />
      ),
    },
    {
      key: 'datadis',
      href: 'https://datadis.es',
      className: 'footer-partner-logo',
      image: (
        <picture>
          <source srcSet={DatadisPartnerWebP} type="image/webp" />
          <img
            src={DatadisPartner}
            alt="Datadis Partner"
            className="footer-partner-logo-img"
            loading="lazy"
            decoding="async"
            width="200"
            height="145"
          />
        </picture>
      ),
    },
    {
      key: 'upv',
      href: 'https://www.upv.es/',
      className: 'footer-upv-logo',
      image: (
        <img
          src={logoUpv}
          alt="Universidad Politécnica de Valencia"
          className="footer-upv-logo-img"
          loading="lazy"
          decoding="async"
        />
      ),
    },
    {
      key: 'unef',
      href: 'https://www.unef.es/',
      className: 'footer-unef-logo',
      image: (
        <img
          src={logoUnef}
          alt="UNEF - Unión Española Fotovoltaica"
          className="footer-unef-logo-img"
          loading="lazy"
          decoding="async"
        />
      ),
    },
    {
      key: 'nvidia-inception',
      href: 'https://www.nvidia.com/en-us/startups/',
      className: 'footer-nvidia-logo',
      image: (
        <img
          src={nvidiaInceptionBadge}
          alt="NVIDIA Inception Program Member"
          className="footer-nvidia-logo-img"
          loading="lazy"
          decoding="async"
          width="167"
          height="72"
        />
      ),
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-curves" aria-hidden="true">
        <div className="footer-curves-inner">
          <img
            src={FooterCurves}
            alt=""
            className="footer-curves-img"
            aria-hidden="true"
          />
        </div>
      </div>

      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand-section">
            <Link to="/" className="footer-logo" aria-label="Inicio">
              <img
                src={Logo}
                alt="Trimergy Logo"
                className="footer-logo-img"
              />
            </Link>
          </div>

          <div className="footer-links-section">
            <div className="footer-services">
              <h3 className="footer-heading">
                <img
                  src={Location}
                  alt="Ubicación"
                  className="footer-heading-icon"
                />
                Servicios
              </h3>
              <ul className="footer-list">
                {serviceLinks.map(({ label, path }) => (
                  <li key={label}>
                    <Link to={path} className="footer-link" discover={false}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-contact">
              <h3 className="footer-heading">
                <img
                  src={Phone}
                  alt="Teléfono"
                  className="footer-heading-icon"
                />
                Contáctanos
              </h3>
              <address className="footer-contact-info">
                {contactItems.map(({ label, href }) => (
                  <a key={label} href={href} className="footer-contact-item">
                    {label}
                  </a>
                ))}
              </address>
            </div>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <div className="footer-logos">
            {partnerLogoLinks.map(({ key, href, className, image }) => (
              <a
                key={key}
                href={href}
                className={`footer-logo-link ${className}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {image}
              </a>
            ))}
          </div>

          <nav className="footer-nav" aria-label="Enlaces legales">
            {policyLinks.map(({ label, path }) => (
              <Link
                key={label}
                to={path}
                className="footer-nav-link"
                discover={false}
              >
                {label}
              </Link>
            ))}
            <button type="button" className="footer-nav-link footer-nav-button" onClick={openPreferences}>
              Gestionar cookies
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
